import { Component, signal } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-preloader',
  imports: [LottieComponent],
  templateUrl: './preloader.component.html',
})
export class PreloaderComponent {
  progress = signal(0);
  lottieOptions = signal<AnimationOptions>({
    path: '/animations/patrik-wheel.json',
    loop: true,
    autoplay: true,
  });

  gradient = 'linear-gradient(90deg, #1C4FE8 7%, #8D1CC2 51%, #D989FF 100%)';

  constructor() {
    const interval = setInterval(() => {
      const val = this.progress();
      if (val < 100) this.progress.update(v => v + 7);
      else {
        clearInterval(interval);
      }
    }, 150);
  }
}
